import '../../css/home/directors.scss';

$(function() {

});